(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire494a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire494a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $33284ae34a44920e$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("hM4yG"), JSON.parse('["hM4yG","index.9bed7192.js","56SFy","black-1.b9e2a0c5.jpg","7V6WN","black-2.a498d6b2.jpg","6hNGn","black-3.59840d4e.jpg","4cWaX","black-4.a3891a45.jpg","jsjdb","black-5.638afd2c.jpg","l3X4Y","blue-1.515b7ea5.jpg","kjkju","blue-2.72f5326f.jpg","f5Q6e","blue-3.8869fda4.jpg","d5b7E","blue-4.5e1a0e59.jpg","C2FeF","blue-5.19f343d9.jpg","klESQ","starlight-1.e1160a9f.jpg","6QxqV","starlight-2.e2f047d6.jpg","9WDED","starlight-3.fa2e190b.jpg","i29Nv","starlight-4.275143dc.jpg","iVZGP","starlight-5.2d017395.jpg","68IMe","purple-1.2629e5d7.jpg","24WuW","purple-2.2f506698.jpg","cqyxa","purple-3.c781bf17.jpg","g9UPc","purple-4.1693b1b0.jpg","1xJpU","purple-5.99ab2118.jpg","9m6k6","orange-1.294b87e6.jpg","heZgo","orange-2.ddc94dc0.jpg","dPPbE","orange-3.f03b86f2.jpg","DLoY0","orange-4.1481c4e0.jpg","abPHL","orange-5.1f52adb4.jpg"]'));

var $e4dc21ce7fcb6385$exports = {};

$e4dc21ce7fcb6385$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "black-1.b9e2a0c5.jpg";


var $ac4644bf7b6ea047$exports = {};

$ac4644bf7b6ea047$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "black-2.a498d6b2.jpg";


var $9a118c22d6a839a2$exports = {};

$9a118c22d6a839a2$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "black-3.59840d4e.jpg";


var $a2aff221c4a2229f$exports = {};

$a2aff221c4a2229f$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "black-4.a3891a45.jpg";


var $a0f0dd5ace4a629d$exports = {};

$a0f0dd5ace4a629d$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "black-5.638afd2c.jpg";


var $c95338ace0057672$exports = {};

$c95338ace0057672$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "blue-1.515b7ea5.jpg";


var $745925545ad8befd$exports = {};

$745925545ad8befd$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "blue-2.72f5326f.jpg";


var $a870344da9c0ade1$exports = {};

$a870344da9c0ade1$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "blue-3.8869fda4.jpg";


var $63704e4240919b6a$exports = {};

$63704e4240919b6a$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "blue-4.5e1a0e59.jpg";


var $1b28f2bbb9e4ca4f$exports = {};

$1b28f2bbb9e4ca4f$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "blue-5.19f343d9.jpg";


var $7d23b8baddf9051e$exports = {};

$7d23b8baddf9051e$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "starlight-1.e1160a9f.jpg";


var $1624e4ebfbfa98f3$exports = {};

$1624e4ebfbfa98f3$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "starlight-2.e2f047d6.jpg";


var $754f20e3b2968efa$exports = {};

$754f20e3b2968efa$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "starlight-3.fa2e190b.jpg";


var $e634fe3fec3091f5$exports = {};

$e634fe3fec3091f5$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "starlight-4.275143dc.jpg";


var $d636b413557d9cb7$exports = {};

$d636b413557d9cb7$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "starlight-5.2d017395.jpg";


var $609fb4ca87118ac1$exports = {};

$609fb4ca87118ac1$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "purple-1.2629e5d7.jpg";


var $44dfc075b60e5a50$exports = {};

$44dfc075b60e5a50$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "purple-2.2f506698.jpg";


var $5b0fe0330b5e5fd8$exports = {};

$5b0fe0330b5e5fd8$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "purple-3.c781bf17.jpg";


var $a1d384852738ebe8$exports = {};

$a1d384852738ebe8$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "purple-4.1693b1b0.jpg";


var $933d7082fd21daa2$exports = {};

$933d7082fd21daa2$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "purple-5.99ab2118.jpg";


var $92bbbbecf9bae4fd$exports = {};

$92bbbbecf9bae4fd$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "orange-1.294b87e6.jpg";


var $6d5e072fc763f522$exports = {};

$6d5e072fc763f522$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "orange-2.ddc94dc0.jpg";


var $c2e5f60e7654167b$exports = {};

$c2e5f60e7654167b$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "orange-3.f03b86f2.jpg";


var $fcd130d9896654bd$exports = {};

$fcd130d9896654bd$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "orange-4.1481c4e0.jpg";


var $ae88579238cd9f3f$exports = {};

$ae88579238cd9f3f$exports = (parcelRequire("aNJCr")).getBundleURL("hM4yG") + "orange-5.1f52adb4.jpg";


var $0a22c6e20035bdaf$var$colorItems = document.querySelectorAll(".color__item");
var $0a22c6e20035bdaf$var$images = document.querySelectorAll(".swiper-image");
$0a22c6e20035bdaf$var$colorItems.forEach(function(item) {
    item.addEventListener("click", function() {
        $0a22c6e20035bdaf$var$colorItems.forEach(function(i) {
            i.classList.remove("active");
        });
        item.classList.add("active");
        var colorId = item.id;
        var newPaths = [];
        switch(colorId){
            case "black":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($e4dc21ce7fcb6385$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($ac4644bf7b6ea047$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($9a118c22d6a839a2$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($a2aff221c4a2229f$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($a0f0dd5ace4a629d$exports)))
                ];
                break;
            case "blue":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($c95338ace0057672$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($745925545ad8befd$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($a870344da9c0ade1$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($63704e4240919b6a$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($1b28f2bbb9e4ca4f$exports)))
                ];
                break;
            case "starlight":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($7d23b8baddf9051e$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($1624e4ebfbfa98f3$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($754f20e3b2968efa$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($e634fe3fec3091f5$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($d636b413557d9cb7$exports)))
                ];
                break;
            case "purple":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($609fb4ca87118ac1$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($44dfc075b60e5a50$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($5b0fe0330b5e5fd8$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($a1d384852738ebe8$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($933d7082fd21daa2$exports)))
                ];
                break;
            case "orange":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($92bbbbecf9bae4fd$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($6d5e072fc763f522$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($c2e5f60e7654167b$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($fcd130d9896654bd$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($ae88579238cd9f3f$exports)))
                ];
                break;
            default:
                break;
        }
        newPaths.forEach(function(path, index) {
            if ($0a22c6e20035bdaf$var$images[index]) $0a22c6e20035bdaf$var$images[index].src = path;
        });
    });
});

})();
//# sourceMappingURL=index.9bed7192.js.map
